exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "article[data-v-4e2bdeea]{width:100%;height:100%;overflow-y:scroll;padding-top:10px;text-align:justify;position:relative;box-sizing:border-box}article h4[data-v-4e2bdeea],article strong[data-v-4e2bdeea]{font-weight:700}article span[data-v-4e2bdeea],article strong[data-v-4e2bdeea]{display:inline}article .tl[data-v-4e2bdeea]{text-align:left}article .tr[data-v-4e2bdeea]{text-align:right}article .tc[data-v-4e2bdeea]{text-align:center}article p[data-v-4e2bdeea]{padding:r(5) 0;text-indent:2em}article .noindent[data-v-4e2bdeea]{text-indent:0}article h4[data-v-4e2bdeea]{text-align:center;padding:r(15) 0}article .indent[data-v-4e2bdeea]{text-indent:2em}article .baseline[data-v-4e2bdeea]{text-decoration:underline;font-weight:700}article span.baseline[data-v-4e2bdeea]{display:inline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-4e2bdeea","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/contract.vue
// module id = 112
// module chunks = 0